import React, { useEffect, useRef } from 'react';
import { Popover } from 'antd';
import './CustomPopover.css';

const CustomPopover = ({ 
  children, 
  content, 
  title, 
  placement = 'bottomRight',
  trigger = 'click',
  className = '',
  width = "200px",
  visible,
  onVisibleChange,
  ...props 
}) => {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (!visible) return;
    const handleScroll = () => {
      if (visible && onVisibleChange) {
        onVisibleChange(false);
      }
    };

    const scrollableParent = document.querySelector('.ant-table-body') 
      || document.querySelector('.ant-table-wrapper')
      || document.querySelector('main')
      || window;

    scrollableParent.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      scrollableParent.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [visible, onVisibleChange]);

  return (
    <Popover
      content={content}
      title={title}
      placement={placement}
      trigger={trigger}
      className={`custom-popover ${className}`}
      open={visible}
      onOpenChange={onVisibleChange}
      {...props}
    >
      {children}
    </Popover>
  );
};

export default CustomPopover;